<style>
.medical-document__sicknote {
  font-size: 0.75rem;
}
</style>

<template>
  <article class="medical-document">
    <print-header
      type="Atestado"
      :date="$moment(active['created_at']).format('DD/MM/YYYY')"
      :patient="patient"
      :doctor="doctor"
    />

    <p class="medical-document__info-title">
      Atestado
    </p>

    <div
      class="medical-document__sicknote"
      v-html="active.note"
    />

    <print-footer :doctor="doctor" />
  </article>
</template>

<script>
import printHeader from './_header.vue'
import printFooter from './_footer.vue'

export default {
  name: 'DrPrintTemplateSickNote',

  components: {
    printHeader,
    printFooter
  },

  props: ['formData', 'active', 'patient', 'doctor'],

  created () {
    console.log('active', this.active)
  }
}
</script>
